module.exports = __webpack_public_path__ + "static/media/funcao.cc98b228.png";